/**
 * Browsers (especially Windows Chrome/Edge) often leave File.type empty for HEIC,
 * which then gets sent as application/octet-stream and rejected by the API.
 */
export function resolveUploadMimeType(file: File): string {
  const mime = (file.type || "").toLowerCase().trim();
  if (mime && mime !== "application/octet-stream") {
    return mime;
  }

  const name = file.name.toLowerCase();
  if (name.endsWith(".heic")) return "image/heic";
  if (name.endsWith(".heif")) return "image/heif";
  if (name.endsWith(".jpg") || name.endsWith(".jpeg")) return "image/jpeg";
  if (name.endsWith(".png")) return "image/png";
  if (name.endsWith(".webp")) return "image/webp";
  if (name.endsWith(".gif")) return "image/gif";
  if (name.endsWith(".mp4")) return "video/mp4";
  if (name.endsWith(".m4v")) return "video/x-m4v";
  if (name.endsWith(".mkv")) return "video/x-matroska";
  if (name.endsWith(".mov")) return "video/quicktime";
  if (name.endsWith(".avi")) return "video/x-msvideo";
  if (name.endsWith(".webm")) return "video/webm";
  if (name.endsWith(".mp3")) return "audio/mpeg";
  if (name.endsWith(".m4a")) return "audio/mp4";
  if (name.endsWith(".aac")) return "audio/aac";
  if (name.endsWith(".wav")) return "audio/wav";
  if (name.endsWith(".ogg") || name.endsWith(".oga")) return "audio/ogg";
  if (name.endsWith(".flac")) return "audio/flac";
  if (name.endsWith(".pdf")) return "application/pdf";

  return mime || "application/octet-stream";
}

/** Returns a File whose .type is set from the extension when the browser omitted it. */
export function withResolvedMimeType(file: File): File {
  const mimeType = resolveUploadMimeType(file);
  if (file.type === mimeType) return file;
  return new File([file], file.name, { type: mimeType, lastModified: file.lastModified });
}
